<template>
    <form @submit.prevent="authenticate">
        <div>
            <jet-label for="password" value="Password" />
            <jet-input id="password" type="password" class="mt-1 block w-full" v-model="form.password" required
                autocomplete="current-password" />
            <div v-if="form.errors.password" class="validation_error_msg">{{ form.errors.password }}</div>
        </div>

        <div class="flex items-center justify-between mt-4">

            <button @click="backToEmailStep" type="button"
                class="inline-flex items-center px-4 py-2 button-color border border-transparent rounded-md font-bold text-sm text-white uppercase hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25 transition bg-gray-500 ">
                Cancel </button>
            <div class="">


                <inertia-link :href="route('password.request')" class="underline text-sm text-gray-600 hover:text-gray-900">
                    Forgot your password
                </inertia-link>

                <jet-button class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    Login
                </jet-button>
            </div>
        </div>
    </form>
</template>

<script>
import JetLabel from "@/Jetstream/Label";
import JetInput from "@/Jetstream/Input";
import JetButton from "@/Jetstream/Button";

export default {
    components: {
        JetLabel,
        JetInput,
        JetButton,
    },
    props: {
        form: {
            type: Object,
            required: true,
        },
        email: {
            type: String,
            required: true,
        },
        isMultipleTenants: {
            type: Boolean,
            required: true,
        },
        selectedTenant: {
            type: [String, Number],
            default: null,
        },

    },
    methods: {
        backToEmailStep() {
            this.$emit("next", {
                step: 1
            });
        },
        authenticate() {
            this.form.errors = {};
            console.log('this.selectedTenant', this.selectedTenant);
            axios.post(route('universal.authenticate'), {
                email: this.form.email,
                password: this.form.password,
                remember: this.form.remember ? 'on' : '',
                tenant_id: this.selectedTenant
            }).then((response) => {
                if (response.data.status === "success") {
                    this.$emit("next", {
                        step: 3,
                    });
                } else {
                    this.form.reset('password');
                }
            }).catch(error => {

                if (error.response && error.response.data && error.response.data.message) {
                    console.log(error.response.data.message);
                    this.form.errors.password = [error.response.data.message][0];

                } else {
                    this.form.errors.password = ["Something went wrong, please try again later"];
                }
                this.form.reset('password');
            });
        },
    },
};
</script>

<style scoped>
.validation_error_msg {
    font-weight: 400;
    margin: 6px 0 0 !important;
    color: red;
}
</style>
